/* eslint-disable react/prop-types */
import InfoIcon from "@mui/icons-material/Info";
import {
  Autocomplete,
  Box,
  Grid,
  IconButton,
  TextField,
  Tooltip,
  darken,
} from "@mui/material";
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import Footer from "components/Footer";
import DashboardLayout from "components/LayoutContainers/DashboardLayout";
import MDBadge from "components/MDBadge";
import MDBox from "components/MDBox";
import DashboardNavbar from "components/Navbars/DashboardNavbar";
import SelectCustomer from "components/SelectCustomer";
import { setHomePage, useMaterialUIController } from "context";
import dayjs from "dayjs";
import DetailDangKySanPham from "layouts/dangKySanPham/detailDangKySanPham";
import { MaterialReactTable } from "material-react-table";
import { MRT_Localization_VI } from "material-react-table/locales/vi";
import { useEffect, useMemo, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { useRecoilState } from "recoil";
import { AlertState } from "states";
import useAxiosPrivate from "../../hooks/useAxiosPrivate";
import {
  API_ROUTES,
  API_ROUTES_V2,
  ID_GROUP_PHUONGXA,
  ID_GROUP_HOIDONG,
  ID_GROUP_NUMBER_SEVEN,
} from "../../utils/constants";
import useAuth from "hooks/useAuth";
import PrintHoSoDangKy from "./printHoSoDangKy";
import PrintIcon from "@mui/icons-material/Print";
import FormDanhGiaHoSo from "./formDanhGiaHoSo";
import { Task } from "@mui/icons-material";
import ShowSanPhamOCOP from "components/ShowSanPhamOCOP/showSanPhamOCOP";

const ALLVALUE = { ma: "ALL", ten: "Tất cả" };

const dicLanDanhGia = {
  1: "Lần đầu",
  2: "Nâng hạng",
  3: "Đánh giá lại",
};
const dictTrangThai = {
  1: "Đang chấm",
  2: "Đã hoàn thành",
  3: "Hồ sơ trả, bổ sung",
};
const dictColorTrangThai = {
  1: "success",
  2: "warning",
  3: "error",
};
function HoSoDangKy() {
  const [controller, dispatch] = useMaterialUIController();
  useEffect(() => {
    setHomePage(dispatch, false);
  }, []);
  const { user } = useAuth();
  const [tableData, setTableData] = useState({});
  const axiosPrivateInstance = useAxiosPrivate();
  const [isError, setIsError] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [isRefetching, setIsRefetching] = useState(false);
  const [alert, setAlert] = useRecoilState(AlertState);
  const [title, setTitle] = useState("");
  const [rowCount, setRowCount] = useState(0);
  const [pagination, setPagination] = useState({
    pageIndex: 0,
    pageSize: 10,
  });
  const [modalOpen, setModalOpen] = useState(false);
  const [optionNhomSanPham, setOptionNhomSanPham] = useState([]);
  const [optionSanPham, setOptionSanPham] = useState([]);
  const [optionSelectSanPham, setOptionSelectSanPham] = useState([]);
  const [detailState, setDetailState] = useState();
  const [openDetail, setOpenDetail] = useState(false);
  const [dataRow, setDataRow] = useState({});
  const navigate = useNavigate();
  const location = useLocation();
  const [validationErrors, setValidationErrors] = useState({});
  //print
  const [detailPrint, setDetailPrint] = useState();
  const [openPrint, setOpenPrint] = useState(false);

  // Extract current query parameters
  const searchParams = new URLSearchParams(location.search);
  const [paramsState, setParamsState] = useState({
    nam: searchParams.get("nam") || null,
    trangthai: searchParams.get("trangthai") || ALLVALUE.ma,
    chuthe: ALLVALUE.ma,
    nhomsanpham: ALLVALUE.ma,
    sanpham: ALLVALUE.ma,
  });

  useEffect(() => {
    const fetchDataDataSanPham = async () => {
      try {
        const response = await axiosPrivateInstance.get(API_ROUTES.SANPHAM);
        const data = response.data?.["data"];
        let list = [{ id: "ALL", ten: "Tất cả" }];
        if (data?.length > 0) {
          list = [...list, ...data];
        }
        setOptionSanPham(list);
        setOptionSelectSanPham(list);
      } catch (error) {
        console.log(error);
        return;
      }
    };
    const fetchDataDataNhomSanPham = async () => {
      try {
        const response = await axiosPrivateInstance.get("nhomsanpham");
        setOptionNhomSanPham(response.data["data"]);
      } catch (error) {
        console.log(error);
        return;
      }
    };
    fetchDataDataSanPham();
    fetchDataDataNhomSanPham();
  }, []);

  //lấy data sản phẩm theo nhóm sản phẩm
  const fetchDataDataSanPhamByNhom = async (nhom) => {
    try {
      const response = await axiosPrivateInstance.get(API_ROUTES.SANPHAM, {
        params: { nhomsanpham: nhom },
      });
      const data = response.data?.["data"];
      let list = [{ id: "ALL", ten: "Tất cả" }];
      if (data?.length > 0) {
        list = [...list, ...data];
      }
      setOptionSelectSanPham(list);
    } catch (error) {
      console.log(error);
      return;
    }
  };
  //Kiểm tra nhóm người dùng với id Group
  const checkGroupUser = (user, idGroup) => {
    let check = false;
    if (user && user.id) {
      if (user?.group?.find((item) => item?.id == idGroup)) {
        check = true;
      }
    }
    return check;
  };
  //kiểm tra đang đăng nhập với nhóm hội đồng = 6
  const isHoiDong = useMemo(() => {
    return checkGroupUser(user, ID_GROUP_HOIDONG);
  }, [user]);
  //kiểm tra nhóm người dùng là 8 - phường/xã
  const isGroupNumberEight = useMemo(() => {
    return checkGroupUser(user, ID_GROUP_PHUONGXA);
  }, [user]);
  //kiểm tra nhóm người dùng là 7
  const isGroupNumberSeven = useMemo(() => {
    return checkGroupUser(user, ID_GROUP_NUMBER_SEVEN);
  }, [user]);
  // Lấy toàn bộ dữ liệu
  const fetchData = async (
    { nam, nhomsanpham, sanpham, trangthai },
    { pageIndex, pageSize }
  ) => {
    if (!tableData.length) {
      setIsLoading(true);
    } else {
      setIsRefetching(true);
    }
    let body = {
      nam: nam && dayjs(nam)?.isValid() ? dayjs(nam)?.get("year") : undefined,
      trangthai: trangthai == ALLVALUE.ma ? undefined : trangthai,
      nhomsanpham: nhomsanpham == ALLVALUE.ma ? undefined : nhomsanpham,
      sanpham: sanpham == ALLVALUE.ma ? undefined : sanpham,
      maquan: isGroupNumberSeven || isHoiDong ? user.maquan : undefined,
      maphuong: isGroupNumberEight ? user.maphuong : undefined,
      pageNumber: pageIndex + 1,
      countNumber: pageSize,
    };
    await axiosPrivateInstance
      .get(API_ROUTES.PHIEUDANGKY, {
        params: body,
      })
      .then((res) => {
        setRowCount(res.data?.totalRecord);
        setTableData(res.data?.data);
      })
      .catch((error) => {
        console.log(error);
        setIsError(true);
        return;
      })
      .finally(() => {
        setIsError(false);
        setIsLoading(false);
        setIsRefetching(false);
      });
  };
  useEffect(() => {
    fetchData(paramsState, pagination);
  }, [paramsState, pagination]);

  const columns = useMemo(
    () => [
      {
        accessorKey: "id",
        header: "id",
        enableEditing: false,
        enableHiding: false,
        enableColumnActions: false,
      },
      {
        accessorKey: "sanpham_ten",
        header: "Sản phẩm",
        size: 200,
      },
      {
        accessorKey: "chuthe_ten",
        header: "Chủ thể",
        size: 200,
      },
      {
        accessorKey: "ngaydanhgia",
        header: "Ngày đánh giá",
        size: 150,
        Cell: ({ cell }) => {
          const value = cell.getValue();
          return dayjs(value)?.isValid()
            ? dayjs(value)?.format("DD/MM/YYYY")
            : value;
        },
      },
      {
        accessorKey: "trangthai",
        header: "Trạng thái",
        size: 150,
        Cell: ({ cell }) => {
          const value = cell.getValue();
          return (
            <MDBox ml={-1}>
              <MDBadge
                badgeContent={dictTrangThai[value]}
                color={dictColorTrangThai[value]}
                variant="gradient"
              />
            </MDBox>
          );
        },
      },
    ],
    []
  );

  const handleToClickDetail = async (row) => {
    const id = row.getValue("id");
    try {
      const response = await axiosPrivateInstance.get(
        API_ROUTES.PHIEUDANGKY + "/" + id
      );
      let detail = { ...response.data };
      detail["landanhgia_ten"] = dicLanDanhGia[detail?.landanhgia];
      detail["ngaydanhgia_format"] = dayjs(detail?.ngaydanhgia)?.isValid()
        ? dayjs(detail?.ngaydanhgia).format("DD/MM/YYYY")
        : detail?.ngaydanhgia;
      detail["trangthai_ten"] = dictTrangThai[detail?.trangthai];
      setDetailState(detail);
      setOpenDetail(true);
    } catch (error) {
      console.log(error);
      return;
    }
  };
  const handelToDanhgiaClick = async (row) => {
    const id = row.getValue("id");
    try {
      const response = await axiosPrivateInstance.get(
        API_ROUTES.PHIEUDANGKY + "/" + id
      );
      let detail = { ...response.data };
      detail["landanhgia_ten"] = dicLanDanhGia[detail?.landanhgia];
      detail["ngaydanhgia_format"] = dayjs(detail?.ngaydanhgia)?.isValid()
        ? dayjs(detail?.ngaydanhgia).format("DD/MM/YYYY")
        : detail?.ngaydanhgia;
      detail["trangthai_ten"] = dictTrangThai[detail?.trangthai];
      setDataRow({ ...detail, rowIndex: row.index });
    } catch (error) {
      setIsError(true);
      return;
    }
    setTitle("Đánh giá hồ sơ đăng ký");
    setValidationErrors({});
    setModalOpen(true);
  };

  const handleChangeDate = (value) => {
    setParamsState((prev) => {
      const year =
        value && dayjs(value)?.isValid()
          ? dayjs(value)?.get("year")
          : undefined;
      searchParams.set("nam", year);
      navigate(`${location.pathname}?${searchParams.toString()}`);
      return {
        ...prev,
        nam: value,
      };
    });
  };

  //change Nhóm sản phẩm
  const handleChangeNhomSanPham = (e) => {
    let { value } = e.target;
    setParamsState((prev) => ({
      ...prev,
      nhomsanpham: value,
      sanpham: ALLVALUE.ma,
    }));
    if (value !== ALLVALUE.ma) {
      fetchDataDataSanPhamByNhom(value);
    } else {
      setOptionSelectSanPham(optionSanPham);
    }
  };

  const handleChangeTrangThai = (e) => {
    const { value } = e.target;
    setParamsState((prev) => ({
      ...prev,
      trangthai: value,
    }));
  };

  const handleToClearDate = () => {
    setParamsState((prev) => ({
      ...prev,
      nam: null,
    }));
  };
  const handleChangeAutoComplete = (key) => (e, newValue) => {
    setParamsState((prev) => ({
      ...prev,
      [key]: newValue ? newValue.id : ALLVALUE.ma,
    }));
  };
  const handleToCloseDetail = () => {
    setOpenDetail(false);
    setDetailState(null);
  };
  const handleSave = async (values) => {
    try {
      const response = await axiosPrivateInstance.put(
        API_ROUTES.PHIEUDANGKY + "/" + values.id,
        { ...values }
      );
      setAlert({
        alert: true,
        message: "Cập nhật đánh giá hồ sơ thành công!",
        type: "success",
      });
      setValidationErrors({});
      setModalOpen(false);
    } catch (error) {
      if (error?.response?.data) {
        let validErrors = {};
        let data = error?.response?.data;
        if (Array.isArray(data)) {
          let value = "";
          value = data?.join(";");
          validErrors = { ...validErrors, another: value };
        } else {
          Object.entries(data).forEach(([key, value]) => {
            let val = "";
            if (Array.isArray(value)) {
              value.map((item) => {
                val += item;
              });
            } else {
              val = value;
            }
            validErrors = { ...validErrors, [key]: val };
          });
        }
        setValidationErrors(validErrors);
      } else {
        setAlert({
          alert: true,
          message: error?.message || "Lỗi! Vui lòng thử lại sau!",
          type: "error",
        });
        console.log(error);
      }
      return;
    }
  };
  const fieldInforDetail = useMemo(() => {
    const result = [
      {
        key: "chuthe_ten",
        name: "Chủ thể",
        xs: 12,
        md: 12,
        lg: 12,
      },
      {
        key: "nhomsanpham_ten",
        name: "Nhóm Sản phẩm",
        xs: 12,
        md: 6,
        lg: 6,
      },
      {
        key: "sanpham_ten",
        name: "Sản phẩm",
        xs: 12,
        md: 6,
        lg: 6,
      },
      {
        key: "nam",
        name: "Năm",
        xs: 12,
        md: 6,
        lg: 6,
      },
      {
        key: "landanhgia_ten",
        name: "Lần đánh giá",
        xs: 12,
        md: 6,
        lg: 6,
      },
      {
        key: "ngaydanhgia_format",
        name: "Ngày đánh giá",
        xs: 12,
        md: 6,
        lg: 6,
      },
      {
        key: "trangthai_ten",
        name: "Trạng thái",
        xs: 12,
        md: 6,
        lg: 6,
      },
      {
        key: "noidung",
        name: "Nội dung",
        xs: 12,
        md: 12,
        lg: 12,
      },
    ];
    return result;
  }, []);
  const fieldInforContent = useMemo(() => {
    const result = [
      {
        key: "noidung_nguongoc",
        name: "Sử dụng nguyên liệu địa phương",
        xs: 12,
        md: 12,
        lg: 12,
      },
      {
        key: "noidung_laodong",
        name: "Sử dụng lao động địa phương",
        xs: 12,
        md: 12,
        lg: 12,
      },
      {
        key: "noidung_ytuong",
        name: "Nguồn gốc ý tưởng sản phẩm",
        xs: 12,
        md: 12,
        lg: 12,
      },
      {
        key: "noidung_bansac",
        name: "Bản sắc/Trí tuệ địa phương",
        xs: 12,
        md: 12,
        lg: 12,
      },
      {
        key: "noidung_khac",
        name: "Nội dung khác",
        xs: 12,
        md: 12,
        lg: 12,
      },
    ];
    return result;
  }, []);
  //print
  const handleToClickPrint = async (row) => {
    const id = row.getValue("id");
    try {
      const response = await axiosPrivateInstance.get(
        API_ROUTES_V2.PHIEUDANGKY + "/" + id
      );
      let detail = { ...response.data };
      detail["landanhgia_ten"] = dicLanDanhGia[detail?.landanhgia];
      detail["maphuong_ten"] = user.maphuong_ten;
      detail["maquan_ten"] = user.maquan_ten;
      setDetailPrint(detail);
      setOpenPrint(true);
    } catch (error) {
      console.log(error);
      return;
    }
  };

  const handleToClosePrint = () => {
    setOpenPrint(false);
    setDetailPrint(null);
  };
  return (
    <DashboardLayout>
      <DashboardNavbar />
      <MDBox
        pt={6}
        py={3}
        sx={{
          backgroundColor: "#fff",
          borderRadius: "0.5rem",
          px: 3,
        }}
      >
        <Grid
          container
          spacing={2}
          rowSpacing={2}
          columnSpacing={{ xs: 1, sm: 2, md: 3 }}
        >
          <Grid item xs={4} md={3} lg={3}>
            <LocalizationProvider dateAdapter={AdapterDayjs}>
              <DatePicker
                value={paramsState?.nam ? dayjs(paramsState.nam) : null}
                views={["year"]}
                onChange={handleChangeDate}
                slotProps={{
                  textField: {
                    InputLabelProps: { shrink: true },
                    placeholder: "---Chọn năm---",
                    fullWidth: true,
                    inputProps: {
                      readOnly: true,
                    },
                  },
                  field: {
                    clearable: true,
                    onClear: handleToClearDate,
                  },
                }}
                label="Năm"
                sx={{
                  ".MuiInputLabel-shrink": {
                    fontSize: "0.875rem",
                    lineHeight: "1.6",
                  },
                }}
              />
            </LocalizationProvider>
          </Grid>
          <Grid item xs={12} md={3} lg={3}>
            <SelectCustomer
              keyValue="nhomsanpham"
              label="Nhóm sản phẩm"
              labelName="ten"
              option={optionNhomSanPham}
              onChange={handleChangeNhomSanPham}
              state={paramsState.nhomsanpham}
              unicode="id"
            />
          </Grid>
          <Grid item xs={12} md={3} lg={3}>
            <Autocomplete
              sx={{
                ".MuiAutocomplete-input": {
                  padding: "7px 4px 7px 16px !important",
                },
              }}
              id="combo-box-sanPham"
              options={optionSelectSanPham}
              getOptionLabel={(option) => option.ten}
              value={
                optionSelectSanPham?.find(
                  (option) => option.id === paramsState.sanpham
                ) || null
              }
              onChange={handleChangeAutoComplete("sanpham")}
              renderInput={(params) => (
                <TextField
                  {...params}
                  label="Sản phẩm"
                  placeholder="Chọn sản phẩm"
                  disabled={optionSanPham?.length > 0 ? false : true}
                />
              )}
              renderOption={(props, options) => (
                <Box component="li" {...props} key={options.id}>
                  {options.ten}
                </Box>
              )}
              fullWidth
              size="small"
            />
          </Grid>
          <Grid item xs={8} md={3} lg={3}>
            <SelectCustomer
              keyValue="trangthai"
              label="Trạng thái"
              labelName="ten"
              option={[
                { id: 1, ten: "Đang chấm" },
                { id: 2, ten: "Đã hoàn thành" },
                { id: 3, ten: "Hồ sơ trả, bổ sung" },
              ]}
              onChange={handleChangeTrangThai}
              state={paramsState.trangthai}
              unicode="id"
            />
          </Grid>
        </Grid>
      </MDBox>
      <MDBox py={3}>
        <MaterialReactTable
          muiToolbarAlertBannerProps={
            isError
              ? {
                  color: "error",
                  children: "Lỗi khi lấy dữ liệu",
                }
              : undefined
          }
          enableRowNumbers
          rowNumberMode="static"
          columns={columns}
          data={tableData}
          enableFilters={true}
          enableHiding={false}
          enableColumnOrdering={false}
          enableDensityToggle={true}
          enableColumnResizing
          enableGrouping
          enableEditing
          manualPagination
          onPaginationChange={setPagination}
          rowCount={rowCount}
          localization={MRT_Localization_VI}
          positionActionsColumn="last"
          displayColumnDefOptions={{
            "mrt-row-actions": {
              size: 80,
            },
          }}
          renderRowActions={({ row, table }) => (
            <Box sx={{ display: "flex" }}>
              {!isHoiDong && (
                <Tooltip arrow placement="left" title="In">
                  <IconButton
                    color="error"
                    onClick={() => handleToClickPrint(row)}
                  >
                    <PrintIcon />
                  </IconButton>
                </Tooltip>
              )}{" "}
              <Tooltip arrow placement="left" title="Chi tiết">
                <IconButton
                  color="success"
                  onClick={() => handleToClickDetail(row)}
                >
                  <InfoIcon />
                </IconButton>
              </Tooltip>
              {row.original.trangthai == 1 && isGroupNumberEight && (
                <Tooltip arrow placement="left" title="Đánh giá">
                  <IconButton
                    color="warning"
                    onClick={() => handelToDanhgiaClick(row)}
                  >
                    <Task />
                  </IconButton>
                </Tooltip>
              )}{" "}
            </Box>
          )}
          initialState={{
            isLoading: true,
            columnVisibility: {
              id: false,
            },
            density: "compact",
          }}
          state={{
            pagination,
            isLoading,
            showAlertBanner: isError,
            showProgressBars: isRefetching,
          }}
          muiTablePaperProps={{
            elevation: 0,
            sx: {
              borderRadius: "0",
              border: "1px solid rgb(211 225 245)",
              backgroundColor: "#fff",
            },
          }}
          muiTableBodyProps={{
            sx: (theme) => ({
              "& tr:nth-of-type(odd)": {
                backgroundColor: darken(theme.palette.background.default, 0.1),
              },
            }),
          }}
          renderDetailPanel={({ row, table }) => {
            const dataItem = row.original;
            return <ShowSanPhamOCOP data={dataItem} />;
          }}
        />
        <DetailDangKySanPham
          data={detailState}
          open={openDetail}
          onClose={handleToCloseDetail}
          fieldInfor={fieldInforDetail}
          fieldContent={fieldInforContent}
        />
        <FormDanhGiaHoSo
          data={dataRow}
          open={modalOpen}
          title={title}
          onClose={() => {
            setModalOpen(false);
            setValidationErrors({});
          }}
          onSubmit={handleSave}
          validationErrors={validationErrors}
          fieldInfor={fieldInforDetail}
        />
        <PrintHoSoDangKy
          data={detailPrint}
          open={openPrint}
          onClose={handleToClosePrint}
        />
      </MDBox>
      <Footer />
    </DashboardLayout>
  );
}

export default HoSoDangKy;
